var map = {
	"src/app/modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"src-app-modules-auth-auth-module"
	],
	"src/app/modules/masters/masters.module": [
		"./src/app/modules/masters/masters.module.ts",
		"default~src-app-modules-masters-masters-module~src-app-modules-performance-performance-module~src-ap~9aff4578",
		"default~src-app-modules-masters-masters-module~src-app-modules-simulation-simulation-module",
		"src-app-modules-masters-masters-module"
	],
	"src/app/modules/performance/performance.module": [
		"./src/app/modules/performance/performance.module.ts",
		"default~src-app-modules-masters-masters-module~src-app-modules-performance-performance-module~src-ap~9aff4578",
		"src-app-modules-performance-performance-module"
	],
	"src/app/modules/simulation/simulation.module": [
		"./src/app/modules/simulation/simulation.module.ts",
		"default~src-app-modules-masters-masters-module~src-app-modules-performance-performance-module~src-ap~9aff4578",
		"default~src-app-modules-masters-masters-module~src-app-modules-simulation-simulation-module",
		"src-app-modules-simulation-simulation-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;